import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/login'
import SignUp from '@/components/signUp/sign-up'
import workPlace from '@/components/workPlace/workPlace'
import Registration from '@/components/registration/registration'
import Entry from '@/components/entry/entry'
import Agreement from '@/components/registration/agreement'
import candidateApplication from '@/components/candidateApplication/candidateApplication'
import PersonalDetails from '@/components/registration/personalDetails'
import ItCertification from '@/components/registration/itCertification'
import Address from '@/components/registration/address'
import EducationalDetails from '@/components/registration/educationalDetails'
import ProfileSummary from '@/components/registration/profileSummary'
import ImageExtracter from '@/components/registration/imageExtracter'
import Documentsupload from '@/components/registration/documentsupload'
import EducationFieldDetails from '@/components/registration/educationFieldDetails'
import qualificationDetails from '@/components/registration/qualificationDetails'
import termsConditions from '@/components/registration/termsConditions'
import videoUpload from '@/components/videoUpload/videoUpload'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/candidateApplication',
      name: 'candidateApplication',
      component: candidateApplication
    },
    {
      path: '/videoUpload',
      name: 'videoUpload',
      component: videoUpload
    },
    {
      path: '/workPlace/:courseID/:universityID',
      name: 'workPlace',
      component: workPlace
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp
    },
    {
      path: '/registration',
      name: 'registration',
      component: Registration,
      children: [
        {
          path: '/itCertification',
          name: 'itCertification',
          component: ItCertification
        },
        {
          path: '/personalDetails',
          name: 'personalDetails',
          component: PersonalDetails
        },
        {
          path: '/address',
          name: 'address',
          component: Address
        },
        {
          path: '/educationalDetails',
          name: 'educationalDetails',
          component: EducationalDetails
        },
        {
          path: '/profileSummary',
          name: 'profileSummary',
          component: ProfileSummary
        },
        {
          path: '/imageExtracter',
          name: 'imageExtracter',
          component: ImageExtracter
        },
        {
          path: '/documentsupload',
          name: 'documentsupload',
          component: Documentsupload
        },
        {
          path: '/educationFieldDetails',
          name: 'educationFieldDetails',
          component: EducationFieldDetails
        },
        {
          path: '/qualificationDetails',
          name: 'qualificationDetails',
          component: qualificationDetails
        },
        {
          path: '/termsConditions',
          name: 'termsConditions',
          component: termsConditions
        }
      ]
    },
    {
      path: '/entry',
      name: 'entry',
      component: Entry
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: Agreement
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js